export default __webpack_public_path__ + "static/MediaContentFive-b89b28e88c646f2444296bba5fc99603.webp";